import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue')
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue')
  },
  {
    path: '/products',
    name: 'Products',
    component: () => import('../views/Products.vue')
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('../views/Contact.vue')
  },
  {
    path: '/product-detail',
    name: 'ProductDetail',
    component: () => import('../views/ProductDetail.vue')
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from) {
    // 如果路径相同（只有查询参数变化），保持当前滚动位置
    if (to.path === from.path) {
      return false;
    }
    // 否则滚动到顶部
    return { x: 0, y: 0 };
  }
})

// 解决 Vue Router 3.x 导航重复/取消错误
const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    // 忽略导航重复和导航取消的错误
    if (err.name !== 'NavigationDuplicated' && !err.message.includes('Navigation cancelled')) {
      return Promise.reject(err)
    }
  })
}

VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    // 忽略导航重复和导航取消的错误
    if (err.name !== 'NavigationDuplicated' && !err.message.includes('Navigation cancelled')) {
      return Promise.reject(err)
    }
  })
}

export default router 